import React, { useEffect, useRef } from 'react';
import { View, Animated, StyleSheet, Platform } from 'react-native';
import { useTheme } from '../../../../../theme';

interface SkeletonLoaderProps {
  variant?: 'event-badge' | 'day-number';
  width?: number | string;
  height?: number;
  borderRadius?: number;
  style?: any;
}

/**
 * SkeletonLoader Component
 * Displays animated skeleton loading placeholders for calendar content
 */
export const SkeletonLoader: React.FC<SkeletonLoaderProps> = ({
  variant = 'event-badge',
  width = '100%',
  height = 20,
  borderRadius = 4,
  style,
}) => {
  const { colors, resolvedTheme } = useTheme();
  const isDark = resolvedTheme === 'dark' && Platform.OS !== 'web';
  const opacity = useRef(new Animated.Value(0.3)).current;

  useEffect(() => {
    const animation = Animated.loop(
      Animated.sequence([
        Animated.timing(opacity, {
          toValue: 1,
          duration: 800,
          useNativeDriver: true,
        }),
        Animated.timing(opacity, {
          toValue: 0.3,
          duration: 800,
          useNativeDriver: true,
        }),
      ])
    );
    animation.start();

    return () => animation.stop();
  }, [opacity]);

  return (
    <Animated.View
      style={[
        styles.skeleton,
        isDark && { backgroundColor: colors.border.default },
        {
          width,
          height,
          borderRadius,
          opacity,
        },
        style,
      ]}
    />
  );
};

const styles = StyleSheet.create({
  skeleton: {
    backgroundColor: '#E0E0E0',
  },
});

export default SkeletonLoader;
